import { z } from "zod";

import { ORDER_INPUT_COPY } from "./order-input-copy";

export function rejectLegacyOrderFields(input: unknown, context: z.RefinementCtx): unknown {
  if (typeof input !== "object" || input === null) return input;
  if (!Object.hasOwn(input, "quantity") && !Object.hasOwn(input, "expectedDeliveryDate")) return input;
  context.addIssue({ code: z.ZodIssueCode.custom, message: ORDER_INPUT_COPY.reloadForm, fatal: true });
  return z.NEVER;
}
